import axios from "axios";
import { getAccessTokenFromLocalStorage } from "../include/token";

const axiosClient = axios.create();

axiosClient.interceptors.request.use((config) => {
  const token = getAccessTokenFromLocalStorage();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

axiosClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // ✅ Show message
      alert("Your session has expired. Please login again.");

      // ✅ Clear storage
      localStorage.clear();

      // ✅ Redirect to login
      window.location.href = "/login"; // or use your router

      // Optional: reject with a generic message
      return Promise.reject({
        status: false,
        code: 401,
        message: "Unauthorized",
      });
    }

    return Promise.reject(error);
  }
);

export default axiosClient;
